export const endpoints = {
  query: '/partition/query',
  setPartitionContacts: '/partition/:id/action-plan/contacts',
  update: '/partition/:id/update',
  remove: '/partition/:partitionId',
}
